import { render, staticRenderFns } from "./ViewProfessionalMembership.vue?vue&type=template&id=60f54bf6&scoped=true"
import script from "./ViewProfessionalMembership.vue?vue&type=script&lang=js"
export * from "./ViewProfessionalMembership.vue?vue&type=script&lang=js"
import style0 from "./ViewProfessionalMembership.vue?vue&type=style&index=0&id=60f54bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f54bf6",
  null
  
)

export default component.exports